(function () {
    const SIT = {
        Q: 'conversation_quiet',
        N: 'conversation_noise',
        TV: 'tv',
        W: 'work_meetings'
    };
    const HL = {
        mild: 'mild',
        moderate: 'moderate',
        severe: 'severe',
        not_sure: 'not_sure'
    };

    let REC_MAP = {
        'ultra_50': { url: '/products/phonak-audeo-infinio-i-r?variant=50047868240199', name: 'Ultra I-50R', handle: 'phonak-audeo-infinio-i-r', variant: 50047868240199 },
        'ultra_70': { url: '/products/phonak-audeo-infinio-i-r?variant=50047868338503', name: 'Ultra I-70R', handle: 'phonak-audeo-infinio-i-r', variant: 50047868338503 },
        'sphere': { url: '/products/phonak-audeo-infinio-i-sr?variant=50047857951047', name: 'Sphere I-90SR', handle: 'phonak-audeo-infinio-i-sr', variant: 50047857951047 },
        'signia': { url: '/products/resound-vivia-microrie-r?variant=51829121057095', name: 'Signia Pure Charge & Go 50', handle: 'resound-vivia-microrie-r', variant: 51829121057095 },
        'resound_7': { url: '/products/resound-vivia-microrie-r?variant=51829120270663', name: 'ReSound Micro RIE 7', handle: 'resound-vivia-microrie-r', variant: 51829120270663 },
        'resound_9': { url: '/products/resound-vivia-microrie-r?variant=51829119484231', name: 'ReSound Micro RIE 9', handle: 'resound-vivia-microrie-r', variant: 51829119484231 }
    };

    function getRecList() {
        const keys = ['ultra_50', 'ultra_70', 'sphere', 'signia', 'resound_7', 'resound_9'];
        return keys.map(function (k) { return REC_MAP[k]; }).filter(Boolean);
    }

    function pickDifferentAlternative(primary, preferred) {
        if (preferred && primary && (preferred.handle !== primary.handle || String(preferred.variant) !== String(primary.variant)))
            return preferred;
        const list = getRecList();
        return list.find(function (r) { return r.handle !== primary.handle || String(r.variant) !== String(primary.variant); }) || list[0];
    }

    function getRecommendation(answers) {
        const hasQ = answers.situations.includes(SIT.Q);
        const hasN = answers.situations.includes(SIT.N);
        const hasTV = answers.situations.includes(SIT.TV);
        const hasW = answers.situations.includes(SIT.W);
        const hl = answers.hearing_loss;
        const severeOrNotSure = hl === HL.severe || hl === HL.not_sure;
        const list = getRecList();

        let rec1, rec2;
        if (hasW) {
            rec1 = REC_MAP.sphere || list[0];
            rec2 = REC_MAP.resound_9 || list[1] || list[0];
        } else if (hasN) {
            if (severeOrNotSure) {
                rec1 = REC_MAP.sphere || list[0];
                rec2 = REC_MAP.resound_9 || list[1] || list[0];
            } else {
                rec1 = REC_MAP.ultra_70 || list[0];
                rec2 = REC_MAP.resound_7 || list[1] || list[0];
            }
        } else {
            rec1 = REC_MAP.ultra_50 || list[0];
            rec2 = REC_MAP.signia || list[1] || list[0];
        }
        rec2 = pickDifferentAlternative(rec1, rec2);

        const situations = answers.situations.map(s => {
            if (s === SIT.Q) 
                return 'Conversations in quiet';
            
            if (s === SIT.N) 
                return 'Conversations in noise';
            
            if (s === SIT.TV) 
                return 'TV';
            
            if (s === SIT.W) 
                return 'Work/meetings';
            
            return s;
        });
        const reasonText = situations.length ? situations.join(' & ') : 'your needs';

        return {primary: rec1, alternative: rec2, reason: reasonText, tvAddon: hasTV};
    }

    function trackEvent(eventName, params) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            ... params
        });
    }

    function initQuiz(container, config) {
        if (! container) 
            return;
        
        if (config.rec_map && config.rec_map.length) {
            REC_MAP = {};
            config.rec_map.forEach(function (r) {
                REC_MAP[r.key] = {
                    handle: r.handle,
                    variant: r.variant,
                    url: r.url,
                    name: r.name || r.title || '',
                    title: r.title,
                    variant_title: r.variant_title,
                    image_url: r.image_url,
                    price: r.price
                };
            });
        }

        const overlay = document.createElement('div');
        overlay.className = 'help-quiz-overlay';
        overlay.id = 'help-quiz-overlay';

        overlay.innerHTML = `
      <div class="help-quiz-header">
        <div class="help-quiz-header-row help-quiz-header-row-1">
          <div class="help-quiz-header-center">
            <div class="help-quiz-social-proof"><img class="help-quiz-trustpilot-stars" src="https://cdn.shopify.com/s/files/1/0260/0229/2782/files/Trustpilot_ratings_5star_RGB.svg?v=1771003411" alt="Trustpilot 5 stars" width="120" height="24"><span class="help-quiz-trusted">Trusted by 200+ users</span></div>
          </div>
          <button type="button" class="help-quiz-close" data-action="close" aria-label="Close">×</button>
        </div>
        <div class="help-quiz-header-row help-quiz-header-row-2">
        <button type="button" class="help-quiz-back" data-action="back" aria-label="Back">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              Back
            </button>
          <div class="help-quiz-progress-bar">
            <div class="help-quiz-progress-track"></div>
            <div class="help-quiz-progress-fill" style="width: 33.33%"></div>
            <div class="help-quiz-progress-nodes">
              <span class="help-quiz-step-dot" data-step="1"></span>
              <span class="help-quiz-step-dot" data-step="2"></span>
              <span class="help-quiz-step-dot" data-step="3"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="help-quiz-body">
        <div class="help-quiz-step is-active" data-step="1">
          <h3 class="help-quiz-question">Main situations to improve</h3>
          <div class="help-quiz-options" data-multi="true">
            <button type="button" class="help-quiz-option" data-value="conversation_quiet">
              <span class="help-quiz-option-checkbox"></span>
              Conversation in quiet
            </button>
            <button type="button" class="help-quiz-option" data-value="conversation_noise">
              <span class="help-quiz-option-checkbox"></span>
              Conversation in noise
            </button>
            <button type="button" class="help-quiz-option" data-value="tv">
              <span class="help-quiz-option-checkbox"></span>
              TV
            </button>
            <button type="button" class="help-quiz-option" data-value="work_meetings">
              <span class="help-quiz-option-checkbox"></span>
              Work / Meetings
            </button>
          </div>
        </div>
        <div class="help-quiz-step" data-step="2">
          <h3 class="help-quiz-question">Hearing loss</h3>
          <div class="help-quiz-options" data-multi="false">
            <button type="button" class="help-quiz-option" data-value="mild">
              <span class="help-quiz-option-radio"></span>
              Mild
            </button>
            <button type="button" class="help-quiz-option" data-value="moderate">
              <span class="help-quiz-option-radio"></span>
              Moderate
            </button>
            <button type="button" class="help-quiz-option" data-value="severe">
              <span class="help-quiz-option-radio"></span>
              Severe
            </button>
            <button type="button" class="help-quiz-option" data-value="not_sure">
              <span class="help-quiz-option-radio"></span>
              Not Sure
            </button>
          </div>
        </div>
        <div class="help-quiz-step" data-step="3">
          <h3 class="help-quiz-question">How important is it for you to hear better?</h3>
          

          <div class="help-quiz-rating-options">
            <div>
              <button type="button" class="help-quiz-rating-option" data-value="1">
                <span>1</span>
              </button>
              <span class="help-quiz-rating-label">not important</span>
            </div>
            <button type="button" class="help-quiz-rating-option" data-value="2">
              <span>2</span>
            </button>
            <button type="button" class="help-quiz-rating-option" data-value="3">
              <span>3</span>
            </button>
            <button type="button" class="help-quiz-rating-option" data-value="4">
              <span>4</span>
            </button>
            <div>
              <button type="button" class="help-quiz-rating-option" data-value="5">
                <span>5</span>
              </button>
              <span class="help-quiz-rating-label">very important</span>
            </div>
          </div>
        </div>
        <div class="help-quiz-results">
          <h3 class="help-quiz-question alig-left-border">Recommended for you....</h3>
          <div class="help-quiz-product-cards"></div>
          <div class="help-quiz-addon" style="display:none">
            <div class="help-quiz-addon-title">TV Connector / TV Streamer</div>
            <div class="help-quiz-addon-desc">Recommended add-on for better TV listening</div>
            <a href="#" class="help-quiz-addon-cta">Add TV Connector</a>
          </div>
        </div>
      </div>
      <div class="help-quiz-footer">
        <button type="button" class="help-quiz-next" disabled>Next</button>
      </div>
    `;

        document.body.appendChild(overlay);

        const steps = overlay.querySelectorAll('.help-quiz-step');
        const resultsEl = overlay.querySelector('.help-quiz-results');
        const backBtn = overlay.querySelector('.help-quiz-back');
        const headerRow2 = overlay.querySelector('.help-quiz-header-row-2');
        const nextBtn = overlay.querySelector('.help-quiz-next');
        const totalSteps = 3;

        let currentStep = 1;
        const answers = {
            situations: [],
            hearing_loss: null,
            importance: null
        };

        function getHandle(key) {
            return config[key] || key;
        }

        const progressFill = overlay.querySelector('.help-quiz-progress-fill');
        const progressFillStops = [20, 50, 80];

        function updateProgress() {
            overlay.querySelectorAll('.help-quiz-step-dot').forEach((dot, i) => {
                dot.classList.toggle('is-complete', i + 1 < currentStep);
                dot.classList.toggle('is-current', i + 1 === currentStep);
            });
            if (progressFill) 
                progressFill.style.width = `${progressFillStops[currentStep - 1] || 80}%`;
        }

        function canProceed() {
            if (currentStep === 1) 
                return answers.situations.length > 0;
            
            if (currentStep === 2) 
                return answers.hearing_loss != null;
            
            if (currentStep === 3) 
                return answers.importance != null;
            
            return false;
        }

        function updateNextState() {
            nextBtn.disabled = ! canProceed();
        }

        function goToStep(step) {
            steps.forEach(s => s.classList.remove('is-active'));
            resultsEl.classList.remove('is-active');
            if (step <= totalSteps) {
                const el = overlay.querySelector(`.help-quiz-step[data-step="${step}"]`);
                if (el) 
                    el.classList.add('is-active');
                
                backBtn.style.visibility = step === 1 ? 'hidden' : 'visible';
                headerRow2.classList.toggle('is-back-visible', step !== 1);
                nextBtn.style.display = 'block';
                nextBtn.textContent = step === totalSteps ? 'See my recommended hearing aids' : 'Next';
                currentStep = step;
                updateProgress();
                updateNextState();
                trackEvent('quiz_step', {step_number: step});
            }
        }

        function showResults() {
            steps.forEach(s => s.classList.remove('is-active'));
            resultsEl.classList.add('is-active');
            backBtn.style.visibility = 'hidden';
            headerRow2.classList.remove('is-back-visible');
            nextBtn.style.display = 'none';
            overlay.querySelectorAll('.help-quiz-step-dot').forEach((dot) => {
                dot.classList.add('is-complete');
                dot.classList.remove('is-current');
            });
            if (overlay.querySelector('.help-quiz-progress-fill')) 
                overlay.querySelector('.help-quiz-progress-fill').style.width = '100%';
            

            const rec = getRecommendation(answers);
            trackEvent('quiz_complete', {});
            trackEvent('results_view', {});

            const cardsEl = resultsEl.querySelector('.help-quiz-product-cards');
            cardsEl.innerHTML = '<div class="help-quiz-loading">Loading recommendations...</div>';

            const tvHandle = (config && config.tv_connector) || 'tv-connector';

            const altDifferent = rec.primary !== rec.alternative && rec.alternative && (rec.primary.handle !== rec.alternative.handle || String(rec.primary.variant) !== String(rec.alternative.variant));
            Promise.all([
                fetch(`/products/${rec.primary.handle}.js`).then(r => r.ok ? r.json() : null),
                altDifferent ? fetch(`/products/${rec.alternative.handle}.js`).then(r => r.ok ? r.json() : null) : Promise.resolve(null),
                rec.tvAddon ? fetch(`/products/${tvHandle}.js`).then(r => r.ok ? r.json() : null) : Promise.resolve(null)
            ]).then(([product1, product2, tvProduct]) => {
                const formatMoney = (cents) => {
                    const fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
                    const val = (cents / 100).toFixed(2);
                    return fmt.replace(/\{\{\s*amount\s*\}\}/g, val).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.floor(cents / 100).toString());
                };

                const benefits = {
                    'sphere': [
                        'Exceptional speech clarity in noisy environments, eliminating background noise',
                        'Significantly reduced listening effort and strain',
                        'Powered by Advanced AI processor with fully automated adaptation to surroundings',
                        'Rechargeable battery powered'
                    ],
                    'ultra_70': [
                        'Impressive sound quality',
                        'Advanced speech understanding with reduced listening effort',
                        'Connect seamlessly to Bluetooth devices and other streaming devices',
                        'Rechargeable battery powered'
                    ],
                    'ultra_50': [
                        'Advanced sound quality',
                        'Good speech understanding with reduced listening effort',
                        'Connect seamlessly to Bluetooth devices and other streaming devices',
                        'Rechargeable battery powered'
                    ],
                    'signia': [
                        'Advanced performance in group conversations',
                        'Seamless connectivity',
                        'Personalised real-time control and optimization with AI assistance',
                        'Rechargeable battery powered'
                    ],
                    'resound_7': [
                        'Impressive speech clarity and understanding in noise',
                        'Natural, vivid sound experience with reduced effort',
                        'Market-leading connectivity with Bluetooth LE Audio and Auracast',
                        'World\'s smallest rechargeable hearing aid'
                    ],
                    'resound_9': [
                        'Superior speech clarity and understanding in noise',
                        'Natural, vivid sound experience with significantly reduced effort',
                        'Market-leading connectivity with Bluetooth LE Audio and Auracast',
                        'World\'s smallest rechargeable hearing aid'
                    ]
                };
                const defaultBenefits = ['Clear sound for TV and speech', 'Background noise reduction', 'Rechargeable and easy to use'];

                const imgUrl = (p) => {
                    const url = p && (p.featured_image || (p.images && p.images[0]));
                    return url ? (url.startsWith('//') ? 'https:' + url : url) : '';
                };

                const findVariant = (product, variantId) => {
                    if (!product || !product.variants) 
                        return null;
                    
                    return product.variants.find(v => String(v.id) === String(variantId));
                };

                const getDisplayTitle = (recItem, product) => {
                    return recItem.title || (product && product.title) || recItem.name || '';
                };

                const getRecKey = (recItem) => {
                    return Object.keys(REC_MAP).find(function (k) {
                        return REC_MAP[k].handle === recItem.handle && String(REC_MAP[k].variant) === String(recItem.variant);
                    });
                };

                const renderCard = (recItem, product, isBest) => {
                    const variant = findVariant(product, recItem.variant);
                    const price = recItem.price != null ? recItem.price : (variant ? variant.price : (product && product.price));
                    const productId = product ? product.id : '';
                    const recKey = getRecKey(recItem);
                    const b = benefits[recKey] || defaultBenefits;
                    const displayTitle = getDisplayTitle(recItem, product);
                    const imageSrc = recItem.image_url || imgUrl(product);
                    return `
            <div class="help-quiz-product-card ${
                        isBest ? 'is-best-match' : ''
                    }">
              <div class="help-quiz-product-image-wrapper"> <img class="help-quiz-product-image" src="${
                          imageSrc
                      }" alt="${
                          displayTitle
                      }"></div>
                <div class="help-quiz-product-info">
                  <h4 class="help-quiz-product-name">${
                          displayTitle
                      }</h4>
                  <p class="help-quiz-product-reason">Recommended for you because you selected ${
                          rec.reason
                      }</p>
                  <div class="help-quiz-product-price">${
                          price ? formatMoney(price) : ''
                      }</div>
                  <ul class="help-quiz-product-benefits">
                    ${
                          b.map(x => `<li>${x}</li>`).join('')
                      }
                  </ul>
                  <a href="${
                          recItem.url
                      }" class="help-quiz-product-cta" data-product-id="${productId}">View details</a>
                </div>
            </div>
          `;
                };

                let html = renderCard(rec.primary, product1, true);
                if (altDifferent && rec.alternative)
                    html += renderCard(rec.alternative, product2, false);
                cardsEl.innerHTML = html;

                if (rec.tvAddon && tvProduct) {
                    const addon = resultsEl.querySelector('.help-quiz-addon');
                    addon.style.display = 'block';
                    addon.querySelector('.help-quiz-addon-cta').href = tvProduct.url;
                }

                cardsEl.querySelectorAll('.help-quiz-product-cta').forEach(a => {
                    a.addEventListener('click', () => {
                        trackEvent('recommendation_click', {product_id: a.dataset.productId});
                    });
                });
            });
        }

        overlay.querySelectorAll('.help-quiz-option').forEach(btn => {
            btn.addEventListener('click', () => {
                const multi = btn.closest('[data-multi]') ?. dataset.multi === 'true';
                const val = btn.dataset.value;
                if (currentStep === 1) {
                    if (multi) {
                        const idx = answers.situations.indexOf(val);
                        if (idx >= 0) 
                            answers.situations.splice(idx, 1);
                         else 
                            answers.situations.push(val);
                         overlay.querySelectorAll('.help-quiz-step[data-step="1"] .help-quiz-option').forEach(o => {
                            o.classList.toggle('is-selected', answers.situations.includes(o.dataset.value));
                        });
                    }
                } else if (currentStep === 2) {
                    answers.hearing_loss = val;
                    overlay.querySelectorAll('.help-quiz-step[data-step="2"] .help-quiz-option').forEach(o => {
                        o.classList.toggle('is-selected', o.dataset.value === val);
                    });
                }
                updateNextState();
            });
        });

        overlay.querySelectorAll('.help-quiz-rating-option').forEach(btn => {
            btn.addEventListener('click', () => {
                const val = btn.dataset.value;
                answers.importance = val;
                overlay.querySelectorAll('.help-quiz-rating-option').forEach(o => {
                    o.classList.toggle('is-selected', o.dataset.value === val);
                });
                updateNextState();
            });
        });

        backBtn.addEventListener('click', () => {
            if (currentStep > 1) 
                goToStep(currentStep - 1);
            
        });

        nextBtn.addEventListener('click', () => {
            if (currentStep < totalSteps) 
                goToStep(currentStep + 1);
             else 
                showResults();
            
        });

        overlay.querySelector('.help-quiz-close') ?. addEventListener('click', () => {
            overlay.classList.remove('is-open');
            document.body.style.overflow = '';
        });

        function openQuiz() {
            const sectionEl = container.closest('[id^="HelpChoose"]');
            const blue = sectionEl ? getComputedStyle(sectionEl).getPropertyValue('--help-choose-blue').trim() : '';
            if (blue) 
                overlay.style.setProperty('--quiz-blue', blue);
            overlay.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            currentStep = 1;
            answers.situations = [];
            answers.hearing_loss = null;
            answers.importance = null;
            goToStep(1);
            overlay.querySelectorAll('.help-quiz-option, .help-quiz-rating-option').forEach(o => o.classList.remove('is-selected'));
            updateNextState();
            trackEvent('quiz_start', {});
        }

        const openBtn = container.querySelector('.help-choose__button[data-quiz-trigger], .help-choose__button');
        if (openBtn) {
            openBtn.addEventListener('click', (e) => {
                const href = openBtn.getAttribute('href') || '';
                if (! href || href === '#') {
                    e.preventDefault();
                    openQuiz();
                }
            });
        }

        if (container.getAttribute('data-quiz-auto-open')) {
            setTimeout(openQuiz, 100);
        }

        updateNextState();
        backBtn.style.visibility = 'hidden';
    }

    function initTidioHide() {
        const hide = () => {
            const el = document.getElementById('tidio-chat');
            if (el) el.style.setProperty('display', 'none', 'important');
        };
        hide();
        const obs = new MutationObserver(hide);
        obs.observe(document.body, { childList: true, subtree: true });
        setInterval(hide, 1500);
    }
    document.addEventListener('DOMContentLoaded', () => {
        initTidioHide();
        const section = document.querySelector('[data-help-quiz-root]');
        if (section) {
            const config = {};
            try {
                const script = document.getElementById('help-quiz-config');
                if (script) 
                    Object.assign(config, JSON.parse(script.textContent));
                
            } catch (_) {}initQuiz(section, config);
        }
    });
})();
